import { buildFallbackAvatar } from "../../../utils/AvatarFallback";

const BoxStaff = ({ data, level, addon = {} }) => {
  let { class: extraClass = "", css = "" } = addon;
  const staffId = data.idu ?? "unknown";

  const fallback = buildFallbackAvatar(data.full_name, {
    size: 52,
    fontSize: 18,
    fontWeight: 700,
    background: "transparent", // เปลี่ยนสีพื้นหลังได้
    // color: "#0066cc",        // ใส่ถ้าอยาก fix สี ไม่ใช้สีตามชื่อ
  });

  const userPhoto =
    data.photo && data.photo !== ""
      ? `
        <div class="image-circle image-loader staff-photo-${staffId}"
             id="staff-photo-${staffId}"
             style="border: 3px solid #edeaea;"
             data-src="${data.photo}">
          ${fallback}
        </div>`
      : `<div class="image-circle" style="border: 3px solid #edeaea;">${fallback}</div>`;

  if (data?.class_code && data.class_code !== "") {
    extraClass += ` class-${data.class_code}`;
  }

  const classNames = [
    "staff",
    `staff-${staffId}`,
    `level-${level}`,
    data.class_code ? `class-${data.class_code}` : "",
    extraClass,
  ]
    .filter(Boolean)
    .join(" ");

  return (
    `<div key="${staffId}" id="staff-${staffId}" class="${classNames}" style="${css}">` +
    `<div class="photo">${userPhoto}</div>` +
    `<div class="detail">` +
    `<span class="position truncate">${data.position}</span>` +
    `<span class="full-name truncate">${data.full_name}</span>` +
    `</div>` +
    `</div>`
  );
};

export default BoxStaff;
